import { Component, OnInit, Input } from '@angular/core';

@Component({
  standalone: true,
  selector: 'tmw-breadcrumbs',
  templateUrl: './breadcrumbs.component.html',
  styleUrls: ['./breadcrumbs.component.scss'],
})
export class BreadcrumbsComponent {
  @Input() title: string | undefined;
  @Input() titleKey: string | undefined;
  @Input()
  breadcrumbItems!:
    | Array<{
        active?: boolean;
        label?: string;
      }>
    | undefined;

  Item!: Array<{
    label?: string;
  }>;

  constructor() {}

  ngOnInit(): void {}
}
